<div class="app-container">
  <router-outlet />
  @if (loading()) {
    <aml-loader [isLoading]="loading()" />
  }
</div>
